// Подключение Jquery
import $ from 'jquery';

window.jQuery = $;
window.$ = $;

window.mobileWidth = 1279;
window.mobileWidthSmall = 768;

// Подключение плагинов
require('./jsUtilities/getBrowserOptions/getBrowserOptions.js');

